import React, { useEffect, useRef } from "react";
import { ReactComponent as SearchIcon } from "../../assets/icons/search_ico.svg";
import { CloseIcon } from "../../assets/icons/icon";

import { analytics, triggerLogEvent } from "../../config/firebase";

const UBSearchBar = ({
  query,
  searchPlaceholder,
  setQuery,
  autoFocus = true,
  handlePopoverOpen,
  className,
  inputRef,
  source,
  handleLogEvent = () => {},
  onFocus = () => {},
  maxLength = 70,
  id,
  ...props
}) => {
  const inputSearchRef = useRef(); // Always call useRef here

  // Use inputRef if provided, otherwise use local inputSearchRef
  const searchRef = inputRef || inputSearchRef;

  return (
    <div className={`ub-search-bar ${className}`} {...props}>
      <SearchIcon
        className="cursorPointer"
        onClick={() => inputSearchRef.current.focus()}
      />
      <input
        id={id}
        ref={searchRef}
        className="search-input"
        value={query}
        onChange={(e) => {
          setQuery(e.target.value);
          if (query.length == 0 && e.target.value.length >= 1) {
            handleLogEvent();
          }
          if (handlePopoverOpen) {
            handlePopoverOpen(e);
          }
        }}
        placeholder={searchPlaceholder}
        autoFocus={autoFocus}
        onFocus={onFocus}
        maxLength={maxLength}
      />
      {query ? (
        <CloseIcon className="closeIcon" onClick={() => setQuery("")} />
      ) : null}
    </div>
  );
};

export default UBSearchBar;
